enum ControleSessaoCaixa {
    Nenhum = 0,
    Franquia = 1,
    Usuario = 2,
}

export default ControleSessaoCaixa;
